@for (alert of alerts(); track alert) {
  <div animate.leave="sobrado-alert--leave"
       class="sobrado-alert {{ cssClass(alert) }} alert-dismissable">
    <div class="icon--box">
      <mat-icon class="icon--size--32">{{ getIconName(alert) }}</mat-icon>
    </div>
    <div class="text--box">{{ alert.message }}</div>
    <div class="close--box">
      <button mat-icon-button
              [type]="ButtonType.Button"
              [class.mat-danger]="alert.type === AlertType.Error"
              (click)="removeAlert(alert)"
              [attr.aria-label]="'front.sng.button.close' | translate">
        <mat-icon class="icon--size--16">close</mat-icon>
      </button>
    </div>
  </div>
}
